"use client";
import CodeMirrorLib, {
  EditorView,
  type ReactCodeMirrorProps,
} from "@uiw/react-codemirror";
import { useEffect, useState } from "react";


export type CodeMirrorProps = ReactCodeMirrorProps & {
  lineWrap?: boolean;
  // optional shorthand to load language packs: 'json' | 'yaml' | string[]
  language?: "json" | "yaml" | Array<"json" | "yaml">;
};

export default function CodeMirror({
  language,
  extensions,
  lineWrap,
  ...props
}: CodeMirrorProps) {
  const [langExts, setLangExts] = useState<any[] | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!language) {
        setLangExts([]);
        return;
      }

      const langs = Array.isArray(language) ? language : [language];
      try {
        const loaders = langs.map(async (l) => {
          if (l === "json")
            return import("@codemirror/lang-json")
              .then((m) => m.json)
              .catch(() => null);
          if (l === "yaml")
            return import("@codemirror/lang-yaml")
              .then((m) => m.yaml)
              .catch(() => null);
          return Promise.resolve(null);
        });

        const mods = await Promise.all(loaders);
        if (cancelled) return;
        const exts = mods.filter(Boolean).map((fn: any) => fn());
        setLangExts(exts.length ? exts : []);
      } catch (e) {
        if (!cancelled) setLangExts([]);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [language]);

  const allExts = (extensions || []).concat(langExts || []);
  if (lineWrap) {
    allExts.push(EditorView.lineWrapping);
  }
  allExts.push(EditorView.theme({ "&": { fontSize: "12px" } }));

  return <CodeMirrorLib {...props} extensions={allExts} />;
}
